export default defineNuxtPlugin(() => {
  const colorMode = useColorMode();

  // Sync jwb-dark class with colorMode
  const syncThemeClass = (theme: string) => {
    if (theme === 'dark') {
      document.documentElement.classList.add('jwb-dark');
    } else {
      document.documentElement.classList.remove('jwb-dark');
    }
  };

  // Initial sync
  syncThemeClass(colorMode.value);

  // Watch for changes
  watch(() => colorMode.value, syncThemeClass);
});